import { DatesRange, FuzzyDatesOffset } from '@utils/types/calendar';
import { FeaturedListingType } from '@utils/types/featuredListing';
import { AmenityV2Enum } from '@components/_shared/amenityV2/constants';

export type MinMaxType =
  | { min?: number | string; max?: number | string }
  | undefined;

export type FilterParamsType = {
  dates?: DatesRange;
  fuzzyDatesOffset?: FuzzyDatesOffset;
  price?: MinMaxType;
  market?: string | null;
  mapBounds?: string;
  neighborhoods?: string[];
  bedrooms?: MinMaxType;
  petFriendly?: boolean;
  amenities?: (keyof typeof AmenityV2Enum)[];
  beds?: MinMaxType;
  bathrooms?: MinMaxType;
  guests?: number;
  search?: string;
};

export type ContextValues = {
  listings: FeaturedListingType[];
  loading: boolean;
  error: unknown;
  filterParams: FilterParamsType;
  resetFilters: () => void;
  changeDates: (dates: DatesRange) => void;
  changeFuzzyDatesOffset: (fuzzyDatesOffset: FuzzyDatesOffset) => void;
  changePrice: (price: MinMaxType) => void;
  changeMarket: (market: string) => void;
  changeNeighborhoods: (neighborhoods: string[]) => void;
  changeMapBounds: (bounds: string) => void;
  changeBedrooms: (bedrooms: MinMaxType) => void;
  changePetFriendly: (value: boolean) => void;
  changeBulkFilters: (filters: FilterParamsType) => void;
  changeSearch: (search: string) => void;
};

export enum ActionsEnum {
  RESET = 'RESET',
  DATES = 'DATES',
  FUZZY_DATES_OFFSET = 'FUZZY_DATES_OFFSET',
  PRICE = 'PRICE',
  MARKET = 'MARKET',
  MAP_BOUNDS = 'MAP_BOUNDS',
  NEIGHBORHOODS = 'NEIGHBORHOODS',
  BEDROOMS = 'BEDROOMS',
  PET_FRIENDLY = 'PET_FRIENDLY',
  BULK_FILTERS = 'BULK_FILTERS',
  SEARCH = 'SEARCH',
}

export type ActionType =
  | {
      type: ActionsEnum.RESET;
    }
  | {
      payload: DatesRange;
      type: ActionsEnum.DATES;
    }
  | {
      payload: FuzzyDatesOffset;
      type: ActionsEnum.FUZZY_DATES_OFFSET;
    }
  | {
      payload: MinMaxType;
      type: ActionsEnum.PRICE;
    }
  | {
      payload: string | null;
      type: ActionsEnum.MARKET;
    }
  | {
      payload: string;
      type: ActionsEnum.MAP_BOUNDS;
    }
  | {
      payload: string[];
      type: ActionsEnum.NEIGHBORHOODS;
    }
  | {
      payload: MinMaxType;
      type: ActionsEnum.BEDROOMS;
    }
  | {
      payload: boolean;
      type: ActionsEnum.PET_FRIENDLY;
    }
  | {
      payload: FilterParamsType;
      type: ActionsEnum.BULK_FILTERS;
    }
  | {
      payload: string;
      type: ActionsEnum.SEARCH;
    };
